import { State } from "./State";
import * as THREE from 'three';
import { LoginScreen } from "../../Auth/LoginScreen.js";

export class MenuState extends State {
    constructor(manager) {
        super(manager);
        this.Overlay = document.getElementById("MenuOverlay");
        this.readyForChangeState = false; // Flag to prevent skipping
        this.towerGltf = null;
    }

    setupButtons() {
    const playBtn = document.getElementById("MenuPlay");
    this.playEvent = async () => {
        if(!this.readyForChangeState) {
            console.log("Still loading lobby...");
            return;
        }

        // Check auth — show login if no valid session
        const valid = await this.manager.Auth.validate()
        if (!valid) {
            await new Promise(resolve => {
                new LoginScreen(this.manager.Auth, async (user) => {
                    if (user) {
                        // Logged in — pull server data into UserData
                        await this.manager.UserData.load()
                    }
                    resolve()
                }).show()
            })
        }

        const { LobbyState } = await import("./LobbyState.js");
        this.manager.changeState(new LobbyState(this.manager));
    }
    playBtn.addEventListener('click', this.playEvent);
}

    async Enter() {
        this.towerGltf = this.manager.AssetLoader.getModel("menuTower");
        const texture = this.manager.AssetLoader.getTexture("menuTowerTexture");
        const light = new THREE.AmbientLight("#f1ecf1", 5);

        if (this.towerGltf) {
            this.towerGltf.scene.traverse((child) => {
                if (child.isMesh) {
                    if (texture) texture.flipY = false;
                    child.material.map = texture;
                    child.material.needsUpdate = true;
                }
            });
            this.manager.Renderer.Scene.add(this.towerGltf.scene);
        }

        this.manager.Renderer.Scene.add(light);
        this.manager.CameraManager.Camera.position.set(3, 2.5, 0);
        this.manager.CameraManager.setMode('ROTATE');

        this.Overlay.classList.replace("invisible", "visible");
        this.setupButtons();

        // START LOBBY LOADING IMMEDIATELY
        console.log("Pre-loading lobby assets...");
        await this.manager.AssetLoader.loadManifestGroup("lobby_assets");
        this.readyForChangeState = true; 
        console.log("Lobby assets ready.");
    }

    Exit() {
        // Proper Disposal

        this.manager.CameraManager.setMode('');
        
        if (this.towerGltf) {
            this.towerGltf.scene.traverse((child) => {
                if (child.isMesh) {
                    child.geometry.dispose();
                    if (child.material.map) child.material.map.dispose();
                    child.material.dispose();
                }
            });
            this.manager.Renderer.Scene.remove(this.towerGltf.scene);
        }


        this.Overlay.classList.replace("visible", "invisible");
        const playBtn = document.getElementById("MenuPlay");
        if (playBtn) playBtn.removeEventListener("click", this.playEvent);
    }
}